import { render, staticRenderFns } from "./AXregister.vue?vue&type=template&id=17f653d3&scoped=true&"
import script from "./AXregister.vue?vue&type=script&lang=js&"
export * from "./AXregister.vue?vue&type=script&lang=js&"
import style0 from "./AXregister.vue?vue&type=style&index=0&id=17f653d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f653d3",
  null
  
)

export default component.exports